import { Provider } from '@angular/core';
import { CONSTITUTION_TICKETS_REPOSITORY } from './application/modal-all-tickets.tokens';
import { HttpConstitutionTicketsRepository } from './infrastructure/http/http-constitution-tickets.repository';
import { GetAllTicketsByRecordIdConstitutionUseCase } from './application/get-all-tickets-by-record-id-constitution.usecase';

export const MODAL_ALL_TICKETS_PROVIDERS: Provider[] = [
  { provide: CONSTITUTION_TICKETS_REPOSITORY, useClass: HttpConstitutionTicketsRepository },
  GetAllTicketsByRecordIdConstitutionUseCase,
];
